import { Player } from "@lottiefiles/react-lottie-player";
import "./instructions.css";
import instructions from "./instructions.json";
import { IAdaptivePracticeContext } from "../../interface/interface";
import { useContext } from "react";
import { AdaptivePracticeContext } from "../../../../context/context";
import { themeAnimation } from '../../theme';

/** One line of the instructions, with whatever it needs to explain under it. */
export interface InstructionPoint {
  point: string;
  subPoints?: { subPoint: string }[];
}

/**
 * What a student is told before they start.
 *
 * The points come from the screen that shows this, because they are the screen's own facts - how
 * long there is, how many questions, how to move between them. Left out, they are the STAAR test's,
 * which is what this overlay was written for and what Rise still passes.
 */
export function AssessmentInstructions(props: {
  title?: string;
  points?: InstructionPoint[];
  startLabel?: string;
  /** What the button does, where the screen wants something other than "the sitting starts now" -
   *  a student reading the instructions again mid-quiz is going back to a question, not starting
   *  anything. Left out, it starts the sitting, as it always has. */
  onClose?: () => void;
} = {}) {
    const APContext: IAdaptivePracticeContext = useContext(
        AdaptivePracticeContext
      );
    const points: InstructionPoint[] = props.points || instructions.points;
  return (
    <div className="instructions-overlay">
      <div className="instructions-modal">

        <div className="instructions-title">
          <h1>{props.title || 'Test Instructions'}</h1>
        </div>

        <div className="instructions-body">
        <div className="skillMasterBoyContainer">
          <div className="skillMasterBoy">
            <Player id={"boy"} style={{ "width": "100%", "height": "100%" }} className={"boy"} autoplay={true} loop={true} speed={1.5} src={themeAnimation('skill_master_boy.json')}></Player>
          </div>
        </div>
          <ul className="main-points">
            {points.map((item, index) => (
              <li key={index} className="main-point">
                {item.point}

                {item.subPoints && (
                  <ul className="sub-points">
                    {item.subPoints.map((sub, subIndex) => (
                      <li key={subIndex} className="sub-point">
                        {sub.subPoint}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="d-flex justify-content-center w-100 pt-2 pb-2">
            <button type="button" className="continue_btn_wrapper d-flex flex-column align-items-center justify-content-center" onClick={() => {
              if (props.onClose) { props.onClose(); return; }
              if (APContext.setShowStartPopup !== undefined) { APContext.setShowStartPopup(false) }
            }}>
                <div id={"continue-btn"}>
                    <Player style={{ "width": "100%", "height": "100%" }} className={"continue-btn"} autoplay={true} loop={true} speed={1.5} src={themeAnimation('done_button.json')}></Player>
                </div>
                <span id={"continue_btn_text"}>{props.startLabel || 'Start Assessment'}</span>
            </button>
        </div>
      </div>
    </div>
  );
}
